import { apiInstance } from "@/api/instance";

export default async function (b4aId) {
  return apiInstance.get(`/b4a/${b4aId}`);
}
